import React from "react";

import ChipsTokenPriceGraphImgUrl from "assets/images/chips-token-price-graph.webp";

export interface NavMenuMethodsHandlers {
	toggleNavMenu: () => void;
}

interface ChipsTokenWidgetProps {
	collapsed: boolean;
}

const ChipsTokenWidget: React.FC<ChipsTokenWidgetProps> = ({ collapsed }) => {
	if (collapsed) {
		return (
			<i
				className={
					'bg-[url("assets/images/chips-token.webp")] block w-6 h-6 rounded-full bg-contain bg-center bg-no-repeat'
				}
			/>
		);
	}

	return (
		<div className="w-full bg-red-dark rounded-[20px] p-3 max-sm:pb-1.5 overflow-hidden">
			<div className="flex items-center gap-2">
				<i
					className={
						'bg-[url("assets/images/chips-token.webp")] block w-8 h-8 rounded-full bg-contain bg-center bg-no-repeat'
					}
				/>
				<p className="text-sm leading-5 font-semibold text-yellow-350">$CHIPS</p>
			</div>
			<div className="mt-1 w-full h-[46px] sm:h-[50px]">
				<img
					src={ChipsTokenPriceGraphImgUrl}
					alt="Chips price"
					className="w-full h-full object-center object-contain"
				/>
			</div>
			<div className="flex items-center justify-between mt-2">
				<p className="text-sm leading-5 font-semibold text-yellow-350">$0.0459</p>
				<p className="text-sm leading-5 font-semibold text-green-400">+4.29</p>
			</div>
		</div>
	);
};

export default ChipsTokenWidget;
